import * as MDL2Icons from '@fluentui/react-icons-mdl2';

/**
 * Helper function to dynamically get MDL2 icon component by name
 */
export const getMDL2Icon = (
  iconName?: string
): React.ComponentType<any> | null => {
  if (!iconName) return null;

  const iconComponentName = iconName.endsWith('Icon')
    ? iconName
    : `${iconName}Icon`;
  const IconComponent = (MDL2Icons as any)[iconComponentName];

  return IconComponent || null;
};
